module.exports = __webpack_public_path__ + "img/reports.f48c82f5.svg";